export default __webpack_public_path__ + "media/images/icons/list-round-dots-44cfb8db32351a92d55262ffd0808502.svg";